"use client";

import styles from "@/styles/hottest-deals/index.module.scss";
import { useState, useEffect } from "react";

import BreadCrumb from "@/components/global/BreadCrumb";
import Csotd from "@/components/home/Bdotd";
import CrazyTopSellers from "@/components/hottest-deals/CrazyTopSellers";
import FeaturedDeals from "@/components/hottest-deals/FeaturedDeals";
import HotSchema from "@/components/hottest-deals/HotSchema";

import systemApi from "@/service/modules/systemApi";

export default function HottestDealsPage() {
  interface BreadcrumbItem {
    name: string;
    url: string;
    current: boolean;
  }

  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItem[]>([]);

  // 获取面包屑数据
  async function getBreadcrumbData() {
    try {
      const productData = await systemApi.getBreadcrumb("hottest-deals");

      if (productData.data) {
        const breadcrumbData = productData.data.breadCrumb;
        // 在面包屑数据最前面插入 "Online Shopping"
        const homeBreadcrumb = {
          name: "Online Shopping",
          url: "/",
          current: false,
        };
        setBreadcrumb([homeBreadcrumb, ...breadcrumbData]);
      }
    } catch (error) {
      console.log(`crazysales数据获取失败： `, error);
    }
  }

  // 获取页面数据
  const getPageData = () => {
    // 获取面包屑数据
    getBreadcrumbData();
  };

  useEffect(() => {
    getPageData();
  }, []);

  return (
    <>
      <div className={`${styles["page-hottest-deals"]}`}>
        {/* 面包屑 */}
        <div className={styles["breadcrumb-wrapper"]}>
          {!!(breadcrumb && breadcrumb.length) && (
            <BreadCrumb BreadList={breadcrumb}></BreadCrumb>
          )}
        </div>

        {/* Csotd */}
        <Csotd />

        {/* Crazy Top Sellers */}
        <CrazyTopSellers />

        {/* Featured Deals */}
        <FeaturedDeals />

        {/* Featured Deals */}
        <HotSchema />
      </div>
    </>
  );
}
